import { FC } from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

interface Props {
  size?: number
  className?: string
}

const Loader: FC<Props> = ({ className, size }) => {
  return <span className={cn(styles.loader, className)} style={{ width: size || 40, height: size || 40 }} />
}

export default Loader
